var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-small",class:_vm.buttonStyle},[_c('div',{staticClass:"state-layer"},[_c('span',{staticClass:"label__medium"},[_vm._v(_vm._s(_vm.buttonText))]),(_vm.icon)?_c('span',{staticClass:"icon"},[_c('i',{staticClass:"material-symbols-outlined"},[_vm._v(_vm._s(_vm.icon))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }